/**
 * SessionStorage utility with auto-expiry support
 * Useful for temporary data that should persist across route changes
 * but auto-clear after a time period or on logout
 */

const SessionStorageUtils = {
  /**
   * Store a value with optional expiry time
   * @param {string} key - The storage key
   * @param {any} value - The value to store
   * @param {number} expiryMinutes - Minutes until expiry (default: 30)
   */
  set: (key, value, expiryMinutes = 30) => {
    const expiryMs = expiryMinutes * 60 * 1000;
    sessionStorage.setItem(
      key,
      JSON.stringify({
        value,
        expiry: Date.now() + expiryMs
      })
    );
  },

  /**
   * Retrieve a value and check if it has expired
   * @param {string} key - The storage key
   * @returns {any} - The stored value, or null if not found or expired
   */
  get: (key) => {
    const stored = sessionStorage.getItem(key);
    if (!stored) return null;

    try {
      const { value, expiry } = JSON.parse(stored);
      
      // Check if expired
      if (Date.now() > expiry) {
        sessionStorage.removeItem(key);
        return null;
      }
      
      return value;
    } catch (e) {
      console.warn(`Error parsing sessionStorage key "${key}":`, e);
      return null;
    }
  },

  /**
   * Remove a specific key
   * @param {string} key - The storage key
   */
  remove: (key) => {
    sessionStorage.removeItem(key);
  },

  /**
   * Clear all session storage (useful on logout)
   */
  clear: () => {
    sessionStorage.clear();
  }
};

export default SessionStorageUtils;
